import { useSyncExternalStore } from 'react';

const QUERY = '(pointer: coarse)';

function subscribe(onChange: () => void) {
  const query = window.matchMedia(QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function getSnapshot() {
  return window.matchMedia(QUERY).matches;
}

const getServerSnapshot = () => false;

export function useChartTooltipTrigger(): 'click' | 'hover' {
  // Recharts' hover mode updates on touchmove, but a tap only focuses its first point.
  // Click mode resolves the tapped coordinate while preserving keyboard navigation.
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) ? 'click' : 'hover';
}
